import { useState, useEffect } from "react";
import { Table, Card, Spinner} from "react-bootstrap";
import axios from "axios";
import { useNavigate, useParams} from "react-router-dom";
import "jspdf-autotable";
import './design/Ficha.css';
import fotodefault from '../assets/images.png'
import '../Components/design/Ficha.css';


const FichaSocio = () => {
    const { rut } = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [urlFoto, setUrlFoto] = useState("");


    const fetchNameById = async (endpoint, id) => {
        if (!id) return "Desconocido";
        try {
            const response = await axios.get(`https://socios.kolpingchile.cl/backend/api/${endpoint}/${id}`);
            return response.data.nombre || "Desconocido";
        } catch (error) {
            console.error(`Error al obtener ${endpoint} con ID ${id}:`, error);
            return "Desconocido";
        }
    };

    const formatDate = (isoString) => {
        if (!isoString) return "";
        const date = new Date(isoString);
        return date.toLocaleDateString("es-CL", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        });
    };

    const rutConGuion = (rut) => {
        if (!rut) return "";

        // Quitar puntos y guion
        let rutLimpio = rut.replace(/\./g, "").replace(/-/g, "");

        // Separar cuerpo y dígito verificador
        const cuerpo = rutLimpio.slice(0, -1);
        const dv = rutLimpio.slice(-1);

        // Formatear con puntos cada 3 dígitos (de derecha a izquierda)
        let cuerpoFormateado = "";
        let contador = 0;

        for (let i = cuerpo.length - 1; i >= 0; i--) {
            cuerpoFormateado = cuerpo[i] + cuerpoFormateado;
            contador++;
            if (contador % 3 === 0 && i !== 0) {
                cuerpoFormateado = "." + cuerpoFormateado;
            }
        }

        return `${cuerpoFormateado}-${dv.toUpperCase()}`; // Retornar con guion y DV en mayúscula
    };
    useEffect(() => {
        const fetchFoto = async () => {
            try {
                const fotoRes = await axios.get(`https://socios.kolpingchile.cl/backend/api/fotos/${rut}`);
                if (fotoRes.data?.imagen) {
                    setUrlFoto(`${fotoRes.data.imagen}`);
                } else {
                    setUrlFoto(null);
                }
            } catch (fotoError) {
                console.warn("Foto no encontrada o error:", fotoError.message);
                setUrlFoto(null);
            }
        };

        if (rut) {
            fetchFoto();
        }
    }, [rut]);



    useEffect(() => {
        if (!rut) return;

        setLoading(true);
        setError(null);

        const fetchData = async () => {
            try {
                const socioRes = await axios.get(`https://socios.kolpingchile.cl/backend/api/socios/${rut}`);
                const data = socioRes.data;
                const tipo_socio = await fetchNameById("tipos", data.tipo_socio);
                const zona = await fetchNameById("zonas", data.zona);
                const region = await fetchNameById("regiones", data.region);
                const comuna = await fetchNameById("comunas", data.comuna);
                const status = await fetchNameById("status", data.status);
                const diocesis = await fetchNameById("diocesis", data.diocesis);
                const familia = await fetchNameById("familias", data.familia);

                setData({
                    ...data,
                    fecha_nacimiento: formatDate(data.fecha_nacimiento),
                    fecha_inicio_socio: formatDate(data.fecha_inicio_socio),
                    fecha_oficializacion: formatDate(data.fecha_oficializacion),
                    tipo_socio,
                    zona,
                    region,
                    comuna,
                    status,
                    diocesis,
                    familia
                });

            } catch (err) {
                setError("Socio no encontrado o error en la consulta.");
                console.error("Error al buscar socio", err);
                navigate("/mostrar");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [rut, navigate]);



    if (loading) return <Spinner animation="border" />;
    if (error) return <p className="text-danger mt-3">{error}</p>;

    return (
        <div className="container mt-4">
            {data && (
                <Card className="mt-4">
                    <div className="text-center">
                        <div
                            style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "20px auto",
                                background: "#f8f9fa",
                                cursor: "pointer",
                            }}
                        >
                            {rut ? (
                                <img
                                    src={urlFoto || fotodefault}
                                    alt="Foto socio"
                                    style={{ maxWidth: "150px", border: "2px solid #ccc" }}
                                />
                            ) : (
                                <p>Sin foto disponible</p>
                            )}
                        </div>

                    </div>

                    <Card.Body className="body">
                        <Card.Title className="text-center" style={{ fontSize: "1.8rem", fontWeight: "bold" }}>
                            {data.nombre} {data.apellido}
                        </Card.Title>

                        <Table striped bordered hover responsive size="sm" style={{ fontSize: "1rem", marginTop: "15px" }}>
                            <tbody>
                                <tr>
                                    <td><strong>N° de socio</strong></td>
                                    <td>{data.n_socio}</td>
                                </tr>
                                <tr>
                                    <td><strong>RUT</strong></td>
                                    <td>{rutConGuion(data.rut)}</td>
                                </tr>
                                <tr>
                                    <td><strong>Teléfono</strong></td>
                                    <td>{data.telefono}</td>
                                </tr>
                                <tr>
                                    <td><strong>Email</strong></td>
                                    <td>{data.email}</td>
                                </tr>
                                <tr>
                                    <td><strong>Tipo Socio</strong></td>
                                    <td>{data.tipo_socio}</td>
                                </tr>
                                <tr>
                                    <td><strong>Zona</strong></td>
                                    <td>{data.zona}</td>
                                </tr>
                                <tr>
                                    <td><strong>Región</strong></td>
                                    <td>{data.region}</td>
                                </tr>
                                <tr>
                                    <td><strong>Comuna</strong></td>
                                    <td>{data.comuna}</td>
                                </tr>
                                <tr>
                                    <td><strong>Dirección</strong></td>
                                    <td>{data.direccion}</td>
                                </tr>
                                <tr>
                                    <td><strong>Fecha de Nacimiento</strong></td>
                                    <td>{data.fecha_nacimiento}</td>
                                </tr>
                                <tr>
                                    <td><strong>Fecha Inicio Socio</strong></td>
                                    <td>{data.fecha_inicio_socio}</td>
                                </tr>
                                <tr>
                                    <td><strong>Fecha de Oficialización</strong></td>
                                    <td>{data.fecha_oficializacion}</td>
                                </tr>
                                <tr>
                                    <td><strong>Oficio</strong></td>
                                    <td>{data.oficio}</td>
                                </tr>
                                <tr>
                                    <td><strong>Status</strong></td>
                                    <td>{data.status}</td>
                                </tr>
                                <tr>
                                    <td><strong>Diocesis</strong></td>
                                    <td>{data.diocesis}</td>
                                </tr>
                                <tr>
                                    <td><strong>Familia</strong></td>
                                    <td>{data.familia}</td>
                                </tr>
                                <tr>
                                    <td><strong>Notas</strong></td>
                                    <td>{data.notas}</td>
                                </tr>
                            </tbody>

                        </Table>
                    </Card.Body>

                </Card>
            )}
        </div>
    );
};

export default FichaSocio;
